import React,{useState,useEffect} from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function TargetAudiencePage() {
    const ID = Cookies.get("log_id");
    const [products,setProducts] = useState([]);
    function Fetch_Products() {
        axios.get(`${url.path}/fetch_products/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var prod = res.data.products;
                setProducts([])
                prod.map((p)=>{
                    setProducts((prevState) =>[
                        ...prevState, p
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          }); 
    }
    useEffect(() =>{
        Fetch_Products();
    }, [])
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    const [product,setProduct] = useState("");
    const [duration,setDuration] = useState("");
    const [description,setDescription] = useState("");
    const [from,setFrom] = useState("");
    const [to,setTo] = useState("");
    const [audience,setAudience] = useState("");
    const navigate = useNavigate();
    function handleRequest(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('product',product);
        formdata.append('duration',duration);
        formdata.append('description',description);
        formdata.append('from',from);
        formdata.append('to',to);
        formdata.append('audience',audience);
        axios.post(`${url.path}/target_audience/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Request Submitted..'
                })
                navigate("/target_audience_requests_cmp");
            }
        }).catch((err) => {
            console.log("ERROR", err);
          }); 
    }
    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Target Audience Request</h1>
                </div>
                <br />
                <form onSubmit={handleRequest}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Product</label>
                            <select value={product} onChange={(e) =>setProduct(e.target.value)}>
                                <option>--Select--</option>
                                {products && products.map((p) =>(
                                    <option value={p.id}>{p.Name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Audience</label>
                            <select value={audience} onChange={(e) =>setAudience(e.target.value)}>
                                <option>--Select--</option>
                                <option value="Tech">Tech</option>
                                <option value="Business">Business</option>
                                <option value="IT">IT</option>
                                <option value="Management">Management</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Duration(days)</label>
                            <input type="number" value={duration} onChange={(e) =>setDuration(e.target.value)}  />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Description</label>
                            <input type="text" value={description} onChange={(e) =>setDescription(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Start Date</label>
                            <input type="date" value={from} onChange={(e) =>setFrom(e.target.value)}  />
                        </div>
                        <div className="form-group">
                            <label>End Date</label>
                            <input type="date" value={to} onChange={(e) =>setTo(e.target.value)} />
                        </div>
                        
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Request</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default TargetAudiencePage;